// WelcomeScreen.jsx -- onboarding step `welcome` (canvas 1). Single job: state the value and start.
import { shell, headline, primaryBtn, spacer, C } from './onboardingStyles';
export default function WelcomeScreen({ onContinue }) {
  return (
    <div style={shell}>
      <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 4, color: C.dim }}>SLIPTRACK</div>
      <div style={{ ...spacer, display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 28 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.5px', color: C.tertiary }}>EXAMPLE LEG</div>
          <div style={{ background: C.card, border: '1px solid #fb923c', borderRadius: 12, padding: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ fontSize: 15, fontWeight: 700 }}>Shots on goal 3+</span>
              <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.5px', color: '#fb923c' }}>LIVE</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: C.secondary }}>
              <span>3rd period, 12:41</span><span style={{ fontWeight: 700, color: C.primary }}>2 of 3</span>
            </div>
            <div style={{ height: 4, borderRadius: 50, background: '#1e3a5f' }}><div style={{ width: '66%', height: 4, borderRadius: 50, background: 'linear-gradient(90deg,#fb923c,#fbbf24)' }} /></div>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <h1 style={{ ...headline, fontSize: 52, lineHeight: 0.95 }}>Every leg,<br />live.</h1>
          <p style={{ margin: 0, fontSize: 16, lineHeight: 1.5, color: C.secondary }}>Sync or screenshot your slips, then follow each leg to the final whistle.</p>
        </div>
      </div>
      <button type="button" style={primaryBtn} onClick={onContinue}>Get started</button>
      <div style={{ marginTop: 14, textAlign: 'center', fontSize: 12, color: C.tertiary }}>Takes about 30 seconds</div>
    </div>
  );
}
